// /var/www/ep-api-v1/textract/shared/clientLineItems.js

const mappingsIndexedByClientId = {
  2781: { // highland fleets
    "interim_rate_cost": "supply_cost",
  } 
}

const getMappedCompanyText = (charge_type_name, clientId) => {
  if (!mappingsIndexedByClientId[clientId] ) return charge_type_name
  return mappingsIndexedByClientId[clientId][charge_type_name] || charge_type_name
}

const updateChargeTextToClientMapping = (charge, clientId) => {
  if (!clientId) return charge
  charge.utility_charge_type = getMappedCompanyText(charge.utility_charge_type, clientId)
}

function applyMappingsToBill(bill, clientId) {
  for (let i in bill.charges) {
    const charge = bill.charges[i]
    bill.charges[i].utility_charge_type = getMappedCompanyText(charge.utility_charge_type, clientId)
  }
}

module.exports = {
  getMappedCompanyText,
  applyMappingsToBill,
  updateChargeTextToClientMapping
}